import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_3u3fpywwwf: FaireBrandEntity = {
  token: "b_3u3fpywwwf",
  type: "brand",
  name: "ManukaGuard",
  avatarUrl:
    "https://cdn.faire.com/fastly/1a0c35505a87269436d913160d66660740905d74e59850dc273b7d96b357c030.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/a176079e974a85e4452af755ad4cb7ba81d8c49e98d1b57d4072bec9cf3ea7a9.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/1a0c35505a87269436d913160d66660740905d74e59850dc273b7d96b357c030.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/a176079e974a85e4452af755ad4cb7ba81d8c49e98d1b57d4072bec9cf3ea7a9.jpeg",
  location: "Monterey, CA, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 12,
  isTopShop: true,
  isInsider: true,
  description:
    "The story starts with the founder, Gavin Gear, who suffered from acid reflux and heartburn for 30 years until he went to New Zealand and created a product using Medical Grade Manuka Honey. He has seen relief now for over 12 years and went on to create more products that are made for everyone and guaranteed to be the natural alternative to conventional medicines. Continually, ManukaGuard isn't like any other Manuka Honey company because it sets the standard for Medical Grade Manuka Honey products to the ultimate high. \n\nToday our commitment remains to reduce suffering by offering drug-free, all-natural remedies that work and to help consumers find the RIGHT honey for the RIGHT health issue. We look forward to continuing to support our customers in taking control of and regaining their health by offering Medical Grade Manuka Honey products for you and your loved ones.\n\n\n",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:18.916Z",
    importedBy: "entity-db-cli",
  },
};
